import { useEffect, useState } from "react";
import { ADMIN_NAV_GROUPS } from "./adminNavConfig";
import { readOpenGroups, writeOpenGroups } from "./adminNavStorage";

const ALL_GROUP_IDS = ADMIN_NAV_GROUPS.map((group) => group.id);

const withGroup = (groupIds, groupId) =>
  !groupId || groupIds.includes(groupId) ? groupIds : [...groupIds, groupId];

const withoutGroups = (groupIds, removedIds) => groupIds.filter((id) => !removedIds.includes(id));

export const useAdminNavOpenGroups = (activeGroupId, visibleGroupIds) => {
  const [openGroupIds, setOpenGroupIds] = useState(() =>
    withGroup(readOpenGroups() ?? ALL_GROUP_IDS, activeGroupId)
  );

  useEffect(() => {
    setOpenGroupIds((groupIds) => withGroup(groupIds, activeGroupId));
  }, [activeGroupId]);

  useEffect(() => {
    writeOpenGroups(openGroupIds);
  }, [openGroupIds]);

  const toggleGroup = (groupId) =>
    setOpenGroupIds((groupIds) =>
      groupIds.includes(groupId) ? withoutGroups(groupIds, [groupId]) : [...groupIds, groupId]
    );
  const expandAll = () => setOpenGroupIds((groupIds) => visibleGroupIds.reduce(withGroup, groupIds));
  const collapseAll = () => setOpenGroupIds((groupIds) => withoutGroups(groupIds, visibleGroupIds));

  return { openGroupIds, toggleGroup, expandAll, collapseAll };
};
